import React from 'react'
import { Box, Container, Link, Paper, Typography, Button, Grid } from '@mui/material'
import LogoBrand from '../../components/LogoBrand'

function TermAndCondition() {
  return (
    <Container maxWidth="sm" sx={{ pb: 7 }}>
      <LogoBrand />
      <Paper
        elevation={0}
        customBorder
        sx={{
          p: 2.4,
        }}
      >
        <Typography variant="h5" sx={{ mb: 3.5, textAlign: 'center', color: '#fff!important' }}>
          Terms and Conditions
        </Typography>
        <Box sx={{ mt: 2 }}>
          {/* <Typography variant="subtitle2">Important to note:</Typography> */}
          <Typography variant="body2" sx={{ mt: 1, color: '#fff!important' }}>
            1. Attendees must be 16+ and must present valid government ID
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, color: '#fff!important' }}>
            2. Event Organizer reserves the right to deny admission or eject any person violating
            the event’s rules, or whose conduct is deemed illegal, disorderly or offensive by
            management.
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, color: '#fff!important' }}>
            3. No alcohol or illicit drugs can be taken into the Festival. If you are caught with
            alcohol or illicit drugs, your ticket will be forfeited and you will be escorted from
            the Festival site with no re-entry. In the case of finding illicit drugs, the matter
            will be referred to the police. They will also be permanently banned from the festival.
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, color: '#fff!important' }}>
            4. Any person who forges or uses another person’s identification documents as their own,
            may be liable for a criminal offense and referred to the police. They will also be
            permanently banner from the festival
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, color: '#fff!important' }}>
            5. Entry may be refused if tickets are damaged or tampered in any way or are not
            purchased through an authorized point of sale.
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, color: '#fff!important' }}>
            6. Tickets will be redeemed once only at the gate for a wristband in order to gain
            access to the festival. Wristband must be worn for the duration of the Festival.
            Wristbands are non-transferable. Wristbands removed from the wrist or tampered with will
            be rendered invalid and will not be replaced. New wristband subject to at door ticket
            price
          </Typography>
        </Box>
      </Paper>
    </Container>
  )
}

export default TermAndCondition
